import { API } from "../../../cache";

async function apiJson(url, opts = {}) {
  const res = await fetch(url, { credentials: "include", ...opts });
  let data = null;
  try { data = await res.json(); } catch { data = null; }
  if (!res.ok) {
    const detail = data?.detail || data?.message || "Request failed";
    const err = new Error(detail);
    err.status = res.status;
    err.body = data;
    throw err;
  }
  return data;
}

export function listReportFavorites() {
  return apiJson(`${API}/report-favorites`);
}

export function addReportFavorite(reportKey) {
  return apiJson(`${API}/report-favorites`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ report_key: reportKey }),
  });
}

export async function removeReportFavorite(reportKey) {
  const res = await fetch(`${API}/report-favorites/${encodeURIComponent(reportKey)}`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!res.ok && res.status !== 204) {
    let data = null;
    try { data = await res.json(); } catch { data = null; }
    const err = new Error(data?.detail || "Failed to remove favorite");
    err.status = res.status;
    throw err;
  }
  return true;
}
